__webpack_require__.p = "https://bundle.stayforlong.com/20251110.8/_next/";